import { BackendPaginationMeta } from './types';

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 50];

export const DEFAULT_EMPTY_TITLE = 'No Record Found';

export const DEFAULT_PAGINATION_META: BackendPaginationMeta = {
  offset: 0,
  limit: 10,
  totalItems: 0,
  totalPages: 0,
  hasNextPage: false,
  hasPreviousPage: false
};
